import { createAction } from "@reduxjs/toolkit";

import {
  createCommentActionTypes,
  deleteCommentActionTypes,
  editCommentActionTypes,
  getCommentsActionTypes,
  getCommentsPortionActionTypes,
  likeCommentActionTypes,
  resetEditCommentIdActionType,
  setEditCommentIdActionType,
  unlikeCommentActionTypes,
} from "./actionTypes";

export const createComment = createAction(
  createCommentActionTypes.request,
  (payload) => ({ payload }),
);

export const createCommentSuccess = createAction(
  createCommentActionTypes.success,
  (payload) => ({ payload }),
);

export const createCommentFailure = createAction(
  createCommentActionTypes.failure,
  (payload) => ({ payload }),
);

export const addPendingComment = createAction(
  createCommentActionTypes.pending,
  (payload) => ({ payload }),
);

export const getComments = createAction(
  getCommentsActionTypes.request,
  (payload) => ({ payload }),
);

export const getCommentsSuccess = createAction(
  getCommentsActionTypes.success,
  (payload) => ({ payload }),
);

export const getCommentsFailure = createAction(
  getCommentsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getCommentsPortion = createAction(
  getCommentsPortionActionTypes.request,
);

export const getCommentsPortionSuccess = createAction(
  getCommentsPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getCommentsPortionFailure = createAction(
  getCommentsPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const likeComment = createAction(likeCommentActionTypes.request);
export const likeCommentSuccess = createAction(likeCommentActionTypes.success);
export const likeCommentFailure = createAction(likeCommentActionTypes.failure);

export const unlikeComment = createAction(unlikeCommentActionTypes.request);
export const unlikeCommentSuccess = createAction(
  unlikeCommentActionTypes.success,
);
export const unlikeCommentFailure = createAction(
  unlikeCommentActionTypes.failure,
);

export const deleteComment = createAction(deleteCommentActionTypes.request);
export const deleteCommentSuccess = createAction(
  deleteCommentActionTypes.success,
);
export const deleteCommentFailure = createAction(
  deleteCommentActionTypes.failure,
);

export const editComment = createAction(editCommentActionTypes.request);
export const editCommentSuccess = createAction(editCommentActionTypes.success);
export const editCommentFailure = createAction(editCommentActionTypes.failure);

export const setEditCommentId = createAction(setEditCommentIdActionType);
export const resetEditCommentId = createAction(resetEditCommentIdActionType);
